
import { HashRouter, BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './Components/SignIn';
import AssignAll from './Components/AssignAll';
import Home from './Components/Home';
import SignOut from './Components/SignOut';
import Profile from './Components/Profile';
import MemberList from './Components/MemberList';
import Print from './Components/Print';

import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import logo from './logo.svg';

import './App.css';
import './index.css';
import './Css/Masonry.css';
import 'primereact/resources/themes/saga-blue/theme.css'; // Theme
import 'primereact/resources/primereact.min.css'; // Core styles
import 'primeicons/primeicons.css'; // Icons
import 'primeflex/primeflex.css';

import reducer from './Imports/reducerImports';
import { Shared } from './Utilities/allContext1';

function App() {

  const { reset4All } = reducer;

  const dispatch = useDispatch(); // dispatch(
  const memberList = useSelector((state) => state.all.memberList);

  useEffect(() => {
    //dispatch(reset4All());
  }, []);

  return (
    <Shared>
      <HashRouter>
        <Routes>
          <Route path="/signin" element={<SignIn />} />          
          <Route path="/home" element={<Home />} />
          <Route path="/assignall" element={<AssignAll />} />
          <Route path="/signout" element={<SignOut />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/print" element={<Print />} />
          <Route path="/memberList" element={<MemberList />} />
          {/* <Route path="/signup" element={<SignUp />} />
          <Route path="/emailsender" element={<EmailSender />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/home" element={<Home />} />
          <Route path="/profile3" element={<UserListItem />} />
          <Route path="/test" element={<Test />} />
          <Route path="/signout" element={<SignOut />} />
          <Route path="*" element={<Navigate to="/signin" />} /> */}
          <Route path="*" element={<Navigate to="/signin" />} />
        </Routes>
        {/* <GoToTopButton /> */}
      </HashRouter> 
    </Shared>
  );
}

export default App;
